import {useEffect} from 'react'
import {useSessionStorage} from 'react-use'

import {DowntimeAnalyticsEventName} from '../consts'
import {useTrackDowntimeDashboardAnalytics} from '../hooks/useTrackDowntimeDashboardAnalytics'

import {useDowntimePlantId} from './DowntimePlantIdProvider'

const VISITED_DOWNTIME_KEY = 'visitedDowntime'

export const DowntimeTrackAnalysisWrapper: React.FC<{children: React.ReactNode}> = ({children}) => {
  const plantId = useDowntimePlantId()
  const [visitedDowntime, setVisitedDowntime] = useSessionStorage(VISITED_DOWNTIME_KEY, 'false')
  const trackAnalyticsEvent = useTrackDowntimeDashboardAnalytics(plantId)

  useEffect(() => {
    if (visitedDowntime === 'false') {
      trackAnalyticsEvent(DowntimeAnalyticsEventName.UserEntersDowntimeDashboard, {})
      setVisitedDowntime('true')
    }
  }, [setVisitedDowntime, trackAnalyticsEvent, visitedDowntime])

  return <>{children}</>
}
